"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.compareAssociations = exports.findSettingByType = exports.sanitizedSettings = exports.removeEmptyLabelsValues = exports.isSAProfilePolicyPath = exports.isResourcePolicyPath = exports.isServerAccessPath = exports.isAccessBuilderPath = exports.isError = exports.isSuccess = exports.isLoading = exports.getApplicationName = exports.areMembersEmpty = exports.massagePolicyBeforeSave = exports.massageLoadedPolicyJSON = exports.massageLoadedPolicy = exports.getMinutesFromHMTime = exports.getTimeInHMWithColonsFromMinutes = exports.getTimeInHMFromMinutes = void 0;

var _moment = _interopRequireDefault(require("moment"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _get = _interopRequireDefault(require("lodash/get"));

var _commonConstants = require("../../utils/common-constants");

var _constants = require("./add/constants");

var _constants2 = require("./view/constants");

var _constant = require("../timezone-selector/constant");

var _commonUtils = require("../../utils/common-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var timeFormat = 'HH:mm:ss';
var dateFormatFinal = 'yyyy-MM-DD HH:mm:ss';
var SIXTY = 60;

var getTimeInHMFromMinutes = function getTimeInHMFromMinutes(minutes) {
  var hours = parseInt(minutes / SIXTY);
  var minute = minutes - hours * SIXTY;
  return "".concat(hours ? _constants2.translatedStrings.hours(hours) : '', " ").concat(minute ? _constants2.translatedStrings.minutes(minute) : '', " ");
};

exports.getTimeInHMFromMinutes = getTimeInHMFromMinutes;

var getTimeInHMWithColonsFromMinutes = function getTimeInHMWithColonsFromMinutes(minutes) {
  if (isNaN(Number(minutes))) {
    return '';
  }

  var hours = parseInt(minutes / SIXTY);
  var minute = minutes - hours * SIXTY;
  return "".concat(hours, ":").concat(minute);
};

exports.getTimeInHMWithColonsFromMinutes = getTimeInHMWithColonsFromMinutes;

var getMinutesFromHMTime = function getMinutesFromHMTime(time) {
  var _time$split = time.split(_commonConstants.COLON_SEPARATOR),
      _time$split2 = _slicedToArray(_time$split, 2),
      _time$split2$ = _time$split2[0],
      hours = _time$split2$ === void 0 ? 0 : _time$split2$,
      _time$split2$2 = _time$split2[1],
      minutes = _time$split2$2 === void 0 ? 0 : _time$split2$2;

  hours = Number(hours) || 0;
  minutes = Number(minutes) || 0;
  return hours * SIXTY + minutes;
};

exports.getMinutesFromHMTime = getMinutesFromHMTime;

var massageLoadedPolicy = function massageLoadedPolicy(_ref, _ref2) {
  var _members$users, _members$tags, _members$tokens, _members$serviceIdent, _conditionJSON$approv, _conditionJSON$approv2, _conditionJSON$approv3, _conditionJSON$approv4, _conditionJSON$approv5, _conditionJSON$approv6, _conditionJSON$approv7, _conditionJSON$approv8, _conditionJSON$approv9, _conditionJSON$approv10, _conditionJSON$approv11, _conditionJSON$approv12, _conditionJSON$approv13, _conditionJSON$approv14, _conditionJSON$approv15, _conditionJSON$approv16, _conditionJSON$approv17, _conditionJSON$approv18, _conditionJSON$approv19;

  var policy = _ref.policy,
      usersData = _ref.usersData,
      groupsData = _ref.groupsData,
      tokensData = _ref.tokensData,
      serviceIdentitiesData = _ref.serviceIdentitiesData,
      isEditMode = _ref.isEditMode,
      notificationMediumDetails = _ref.notificationMediumDetails;
  var cloneNamePrefix = _ref2.cloneNamePrefix,
      consumersList = _ref2.consumersList;
  var id = policy.id,
      name = policy.name,
      description = policy.description,
      members = policy.members,
      permissions = policy.permissions,
      roles = policy.roles,
      accessType = policy.accessType,
      condition = policy.condition,
      isReadOnly = policy.isReadOnly,
      isActive = policy.isActive,
      isDraft = policy.isDraft,
      accessLevel = policy.accessLevel,
      resourceLabels = policy.resourceLabels,
      settings = policy.settings,
      scopes = policy.scopes;
  var conditionJSON = condition && condition;
  var users = members === null || members === void 0 ? void 0 : (_members$users = members.users) === null || _members$users === void 0 ? void 0 : _members$users.map(function (_ref3) {
    var id = _ref3.id;
    return id;
  });
  var tags = members === null || members === void 0 ? void 0 : (_members$tags = members.tags) === null || _members$tags === void 0 ? void 0 : _members$tags.map(function (_ref4) {
    var id = _ref4.id;
    return id;
  });
  var tokens = members === null || members === void 0 ? void 0 : (_members$tokens = members.tokens) === null || _members$tokens === void 0 ? void 0 : _members$tokens.map(function (_ref5) {
    var id = _ref5.id;
    return id;
  });
  var serviceIdentities = members === null || members === void 0 ? void 0 : (_members$serviceIdent = members.serviceIdentities) === null || _members$serviceIdent === void 0 ? void 0 : _members$serviceIdent.map(function (_ref6) {
    var id = _ref6.id;
    return id;
  });
  var approvalUsers = (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv = conditionJSON.approval) === null || _conditionJSON$approv === void 0 ? void 0 : (_conditionJSON$approv2 = _conditionJSON$approv.approvers) === null || _conditionJSON$approv2 === void 0 ? void 0 : _conditionJSON$approv2.userIds) || [];
  var approvalGroups = (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv3 = conditionJSON.approval) === null || _conditionJSON$approv3 === void 0 ? void 0 : (_conditionJSON$approv4 = _conditionJSON$approv3.approvers) === null || _conditionJSON$approv4 === void 0 ? void 0 : _conditionJSON$approv4.tags) || [];
  var approvalChannels = (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv5 = conditionJSON.approval) === null || _conditionJSON$approv5 === void 0 ? void 0 : (_conditionJSON$approv6 = _conditionJSON$approv5.approvers) === null || _conditionJSON$approv6 === void 0 ? void 0 : _conditionJSON$approv6.channelIds) || [];
  var slackAppChannels = (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv7 = conditionJSON.approval) === null || _conditionJSON$approv7 === void 0 ? void 0 : (_conditionJSON$approv8 = _conditionJSON$approv7.approvers) === null || _conditionJSON$approv8 === void 0 ? void 0 : _conditionJSON$approv8.slackAppChannels) || [];
  var teamsAppChannels = (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv9 = conditionJSON.approval) === null || _conditionJSON$approv9 === void 0 ? void 0 : (_conditionJSON$approv10 = _conditionJSON$approv9.approvers) === null || _conditionJSON$approv10 === void 0 ? void 0 : _conditionJSON$approv10.teamsAppChannels) || [];
  var allUser = getAllMember(users);
  var allGroup = getAllMember(tags);
  var allToken = getAllMember(tokens);
  var allServiceIdentity = getAllMember(serviceIdentities);

  var _getConditionFields = getConditionFields(conditionJSON),
      isDateTime = _getConditionFields.isDateTime,
      timezone = _getConditionFields.timezone,
      dateSchedule = _getConditionFields.dateSchedule,
      startDate = _getConditionFields.startDate,
      endDate = _getConditionFields.endDate,
      daysSchedule = _getConditionFields.daysSchedule,
      startTime = _getConditionFields.startTime,
      endTime = _getConditionFields.endTime,
      selectedDays = _getConditionFields.selectedDays;

  var massagedPolicy = {
    id: id,
    name: isEditMode ? name : "".concat(cloneNamePrefix).concat(name),
    description: description,
    allUser: allUser,
    allServiceIdentity: allServiceIdentity,
    allToken: allToken,
    allGroup: allGroup,
    isReadOnly: isEditMode ? isReadOnly : false,
    isActive: isActive,
    isDraft: isDraft,
    permissions: permissions ? permissions.map(function (permission) {
      var isInline = permission.isInline,
          actions = permission.actions,
          resources = permission.resources,
          name = permission.name,
          id = permission.id,
          description = permission.description,
          consumer = permission.consumer;
      var consumerObject = consumersList === null || consumersList === void 0 ? void 0 : consumersList.find(function (consumerItem) {
        return consumerItem.name === consumer;
      });
      return isInline ? {
        id: isEditMode ? id : (0, _uniqueId.default)('inline-permission-'),
        actions: actions.join(','),
        resources: resources.join(','),
        name: isEditMode ? name : "".concat(cloneNamePrefix).concat(name),
        description: description,
        consumer: consumerObject,
        isExistingInline: isEditMode,
        isInline: isInline
      } : _objectSpread(_objectSpread({}, permission), {}, {
        isInline: false,
        isExistingInline: false,
        consumer: consumerObject
      });
    }) : [],
    roles: roles ? roles.map(function (role) {
      if (!(0, _isEmpty.default)(role.permissions)) {
        var _permissions = role.permissions.map(function (permission) {
          var consumerObject = consumersList === null || consumersList === void 0 ? void 0 : consumersList.find(function (consumerItem) {
            return consumerItem.name === permission.consumer;
          });
          return _objectSpread(_objectSpread({}, permission), {}, {
            consumer: consumerObject
          });
        });

        return _objectSpread(_objectSpread({}, role), {}, {
          permissions: _permissions
        });
      } else {
        return role;
      }
    }) : [],
    allowDeny: accessType,
    accessLevel: accessLevel,
    resourceLabels: resourceLabels,
    settings: settings,
    scopes: scopes || [],
    isIpAddress: Boolean(conditionJSON === null || conditionJSON === void 0 ? void 0 : conditionJSON.ipAddress),
    ipAddress: (conditionJSON === null || conditionJSON === void 0 ? void 0 : conditionJSON.ipAddress) || '',
    isDateTime: isDateTime,
    timezone: timezone,
    dateSchedule: dateSchedule,
    startDate: startDate,
    endDate: endDate,
    daysSchedule: daysSchedule,
    startTime: startTime,
    endTime: endTime,
    selectedDays: selectedDays,
    stepUpVerificationEnabled: (0, _get.default)(conditionJSON, 'stepUpCondition.factor', '') === 'TOTP',
    stepUpVerificationAlwaysPrompt: (0, _get.default)(conditionJSON, 'stepUpCondition.alwaysPrompt', true),
    isApprovals: conditionJSON !== null && conditionJSON !== void 0 && conditionJSON.approval ? true : false,
    notificationMedium: (0, _isEmpty.default)(notificationMediumDetails) ? [] : notificationMediumDetails,
    isChannelsRequired: (notificationMediumDetails === null || notificationMediumDetails === void 0 ? void 0 : notificationMediumDetails.type) === _constants.IS_SLACK,
    channelList: approvalChannels || [],
    slackAppChannels: slackAppChannels,
    teamsAppChannels: teamsAppChannels || [],
    tagList: getMemberObjects(approvalGroups, groupsData, 'userTagId'),
    userList: getMemberObjects(approvalUsers, usersData, 'userId'),
    validFor: conditionJSON !== null && conditionJSON !== void 0 && (_conditionJSON$approv11 = conditionJSON.approval) !== null && _conditionJSON$approv11 !== void 0 && _conditionJSON$approv11.isValidForInDays ? conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv12 = conditionJSON.approval) === null || _conditionJSON$approv12 === void 0 ? void 0 : _conditionJSON$approv12.validFor : getTimeInHMWithColonsFromMinutes(conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv13 = conditionJSON.approval) === null || _conditionJSON$approv13 === void 0 ? void 0 : _conditionJSON$approv13.validFor),
    isValidForInDays: conditionJSON !== null && conditionJSON !== void 0 && (_conditionJSON$approv14 = conditionJSON.approval) !== null && _conditionJSON$approv14 !== void 0 && _conditionJSON$approv14.isValidForInDays ? true : false,
    approvalMaxTime: getTimeInHMWithColonsFromMinutes(conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv15 = conditionJSON.approval) === null || _conditionJSON$approv15 === void 0 ? void 0 : _conditionJSON$approv15.timeToApprove),
    required: (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv16 = conditionJSON.approval) === null || _conditionJSON$approv16 === void 0 ? void 0 : (_conditionJSON$approv17 = _conditionJSON$approv16.managerApproval) === null || _conditionJSON$approv17 === void 0 ? void 0 : _conditionJSON$approv17.required) || false,
    condition: (conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$approv18 = conditionJSON.approval) === null || _conditionJSON$approv18 === void 0 ? void 0 : (_conditionJSON$approv19 = _conditionJSON$approv18.managerApproval) === null || _conditionJSON$approv19 === void 0 ? void 0 : _conditionJSON$approv19.condition) || 'Any'
  };
  var actualUsers = getMemberObjects(users, usersData, 'userId');
  var actualGroups = getMemberObjects(tags, groupsData, 'userTagId');
  var actualTokens = getMemberObjects(tokens, tokensData, 'id');
  var actualServiceIdentities = getMemberObjects(serviceIdentities, serviceIdentitiesData, 'userId');
  massagedPolicy['user'] = users ? actualUsers : [];
  massagedPolicy['group'] = tags ? actualGroups : [];
  massagedPolicy['token'] = tokens ? actualTokens : [];
  massagedPolicy['serviceIdentity'] = serviceIdentities ? actualServiceIdentities : [];
  return massagedPolicy;
};

exports.massageLoadedPolicy = massageLoadedPolicy;

var getMemberObjects = function getMemberObjects(members, membersData, idProperty) {
  var memberObjects = [];

  if (members) {
    var _loop = function _loop(itr) {
      var actualUser = membersData === null || membersData === void 0 ? void 0 : membersData.find(function (member) {
        return member[idProperty] === members[itr];
      });

      if (actualUser) {
        memberObjects.push(actualUser);
      }
    };

    for (var itr = 0; itr < members.length; itr++) {
      _loop(itr);
    }
  }

  memberObjects.sort(function (member1, member2) {
    return ((member1 === null || member1 === void 0 ? void 0 : member1.name) || '').localeCompare(member2 === null || member2 === void 0 ? void 0 : member2.name);
  });
  return memberObjects;
};

var getAllMember = function getAllMember(members) {
  var allMember = false;

  if (members && members.length >= 1) {
    allMember = members[0] === '*';
  }

  return allMember;
};

var getConditionFields = function getConditionFields(conditionJSON) {
  var isDateTime = !!(conditionJSON !== null && conditionJSON !== void 0 && conditionJSON.timeOfAccess);

  if (!isDateTime) {
    return {
      isDateTime: false,
      daysSchedule: false,
      dateSchedule: false,
      timezone: null,
      startDate: null,
      endDate: null,
      startTime: null,
      endTime: null,
      selectedDays: []
    };
  } else {
    var _timeOfAccess$dateSch, _timeOfAccess$daysSch;

    var timeOfAccess = conditionJSON.timeOfAccess;
    var dateSchedule = !!timeOfAccess.dateSchedule;
    var selectedTimezone = ((_timeOfAccess$dateSch = timeOfAccess.dateSchedule) === null || _timeOfAccess$dateSch === void 0 ? void 0 : _timeOfAccess$dateSch.timezone) || ((_timeOfAccess$daysSch = timeOfAccess.daysSchedule) === null || _timeOfAccess$daysSch === void 0 ? void 0 : _timeOfAccess$daysSch.timezone);
    var timezone = selectedTimezone ? _constant.timezones.find(function (t) {
      return t.value === selectedTimezone;
    }) : null;
    var startDate = isDateTime && dateSchedule ? (0, _moment.default)(timeOfAccess.dateSchedule.fromDate, dateFormatFinal) : null;
    var endDate = isDateTime && dateSchedule ? (0, _moment.default)(timeOfAccess.dateSchedule.toDate, dateFormatFinal) : null;
    var daysSchedule = !!timeOfAccess.daysSchedule;
    var startTime = isDateTime && daysSchedule ? (0, _moment.default)(timeOfAccess.daysSchedule.fromTime, timeFormat) : null;
    var endTime = isDateTime && timeOfAccess.daysSchedule ? (0, _moment.default)(timeOfAccess.daysSchedule.toTime, timeFormat) : null;
    var selectedDays = isDateTime && timeOfAccess.daysSchedule ? timeOfAccess.daysSchedule.days.map(function (day) {
      return (0, _startCase.default)(day.toLowerCase());
    }) : [];
    return {
      isDateTime: isDateTime,
      timezone: timezone,
      dateSchedule: dateSchedule,
      startDate: startDate,
      endDate: endDate,
      daysSchedule: daysSchedule,
      startTime: startTime,
      endTime: endTime,
      selectedDays: selectedDays
    };
  }
};

var massageLoadedPolicyJSON = function massageLoadedPolicyJSON(policy, isEditMode, _ref7) {
  var cloneNamePrefix = _ref7.cloneNamePrefix;

  var _ref8 = policy !== null && policy !== void 0 ? policy : {},
      name = _ref8.name,
      permissions = _ref8.permissions,
      roles = _ref8.roles,
      members = _ref8.members;

  var getMemberNames = function getMemberNames(entity) {
    if (!(0, _isEmpty.default)(entity)) {
      return entity.map(function (_ref9) {
        var name = _ref9.name;
        return {
          name: name
        };
      });
    } else {
      return undefined;
    }
  }; //Assigning attribute values such as id to undefined so as to ignore it from the object formed.


  return {
    JSONInputData: JSON.stringify(_objectSpread(_objectSpread({}, policy), {}, {
      id: undefined,
      isReadOnly: undefined,
      roles: roles && roles.length ? roles : undefined,
      name: isEditMode ? name : "".concat(cloneNamePrefix).concat(name),
      permissions: permissions === null || permissions === void 0 ? void 0 : permissions.map(function (permission) {
        var isInline = permission.isInline,
            name = permission.name;

        if (isInline) {
          return _objectSpread(_objectSpread({}, permission), {}, {
            name: isEditMode ? name : "".concat(cloneNamePrefix).concat(name),
            isInline: undefined,
            id: undefined,
            isReadOnly: undefined
          });
        } else {
          return {
            name: name
          };
        }
      }),
      members: !(0, _isEmpty.default)(members) ? {
        tags: getMemberNames(members === null || members === void 0 ? void 0 : members.tags),
        tokens: getMemberNames(members === null || members === void 0 ? void 0 : members.tokens),
        users: getMemberNames(members === null || members === void 0 ? void 0 : members.users),
        serviceIdentities: getMemberNames(members === null || members === void 0 ? void 0 : members.serviceIdentities)
      } : {}
    }), null, 4)
  };
};

exports.massageLoadedPolicyJSON = massageLoadedPolicyJSON;

var massagePolicyBeforeSave = function massagePolicyBeforeSave(values, translatedStrings, isConditionTypeJSON, settings, scopes, requiresHierarchicalModel) {
  var ipAddress = values.ipAddress,
      isDateTime = values.isDateTime,
      dateSchedule = values.dateSchedule,
      daysSchedule = values.daysSchedule,
      startDate = values.startDate,
      endDate = values.endDate,
      startTime = values.startTime,
      endTime = values.endTime,
      timezone = values.timezone,
      selectedDays = values.selectedDays,
      name = values.name,
      allUser = values.allUser,
      allGroup = values.allGroup,
      allToken = values.allToken,
      allServiceIdentity = values.allServiceIdentity,
      user = values.user,
      group = values.group,
      serviceIdentity = values.serviceIdentity,
      token = values.token,
      description = values.description,
      allowDeny = values.allowDeny,
      roles = values.roles,
      permissions = values.permissions,
      isReadOnly = values.isReadOnly,
      isActive = values.isActive,
      isDraft = values.isDraft,
      isApprovals = values.isApprovals,
      notificationMedium = values.notificationMedium,
      channelList = values.channelList,
      tagList = values.tagList,
      userList = values.userList,
      approvalMaxTime = values.approvalMaxTime,
      validFor = values.validFor,
      validForDays = values.validForDays,
      isValidForInDays = values.isValidForInDays,
      stepUpVerificationEnabled = values.stepUpVerificationEnabled,
      stepUpVerificationAlwaysPrompt = values.stepUpVerificationAlwaysPrompt,
      accessLevel = values.accessLevel,
      resourceLabels = values.resourceLabels,
      slackAppChannels = values.slackAppChannels,
      teamsAppChannels = values.teamsAppChannels,
      required = values.required,
      condition = values.condition;
  var rolesArr = [];
  var permissionsArr = [];

  if (roles && roles.length) {
    for (var index = 0; index < roles.length; index++) {
      var role = roles[index];
      var roleWithId = {
        id: role.id
      };
      rolesArr.push(roleWithId);
    }
  }

  if (permissions && permissions.length) {
    for (var _index = 0; _index < permissions.length; _index++) {
      var permission = permissions[_index];
      var id = permission.id,
          _name = permission.name,
          consumer = permission.consumer,
          resources = permission.resources,
          actions = permission.actions,
          isInline = permission.isInline,
          isExistingInline = permission.isExistingInline,
          _description = permission.description;

      if (isInline) {
        var inlinePermission = {
          id: isExistingInline ? id : undefined,
          name: _name,
          consumer: consumer === null || consumer === void 0 ? void 0 : consumer.name,
          resources: resources.split(','),
          actions: actions.split(','),
          description: _description
        };
        permissionsArr.push(inlinePermission);
      } else {
        var permissionWithId = {
          id: permission.id
        };
        permissionsArr.push(permissionWithId);
      }
    }
  }

  var conditionsObject = {};
  var membersObj = {};

  if (allUser) {
    membersObj['users'] = [{
      id: '*'
    }];
  } else {
    if (user) {
      membersObj['users'] = user.map(function (_ref10) {
        var userId = _ref10.userId;
        return {
          id: userId
        };
      });
    }
  }

  if (allGroup) {
    membersObj['tags'] = [{
      id: '*'
    }];
  } else {
    if (group) {
      membersObj['tags'] = group.map(function (_ref11) {
        var userTagId = _ref11.userTagId;
        return {
          id: userTagId
        };
      });
    }
  }

  if (allToken) {
    membersObj['tokens'] = [{
      id: '*'
    }];
  } else {
    if (token) {
      membersObj['tokens'] = token.map(function (_ref12) {
        var id = _ref12.id;
        return {
          id: id
        };
      });
    }
  }

  if (allServiceIdentity) {
    membersObj['serviceIdentities'] = [{
      id: '*'
    }];
  } else {
    if (serviceIdentity) {
      membersObj['serviceIdentities'] = serviceIdentity.map(function (_ref13) {
        var userId = _ref13.userId;
        return {
          id: userId
        };
      });
    }
  }

  if (ipAddress) conditionsObject['ipAddress'] = ipAddress.split(' ').join('');

  if (isDateTime) {
    conditionsObject['timeOfAccess'] = {};

    if (dateSchedule) {
      conditionsObject['timeOfAccess'].dateSchedule = {
        fromDate: (0, _moment.default)(startDate).format(dateFormatFinal),
        toDate: (0, _moment.default)(endDate).format(dateFormatFinal),
        timezone: timezone.value
      };
    } else {
      conditionsObject['timeOfAccess'].dateSchedule = null;
    }

    if (daysSchedule) {
      conditionsObject['timeOfAccess'].daysSchedule = {
        fromTime: (0, _moment.default)(startTime).format(timeFormat),
        toTime: (0, _moment.default)(endTime).format(timeFormat),
        timezone: timezone.value,
        days: selectedDays.map(function (day) {
          return day.toUpperCase();
        })
      };
    } else {
      conditionsObject['timeOfAccess'].daysSchedule = null;
    }
  }

  if (stepUpVerificationEnabled) {
    conditionsObject.stepUpCondition = {
      factor: 'TOTP',
      alwaysPrompt: stepUpVerificationAlwaysPrompt
    };
  }

  if (isApprovals) {
    var approvalsObj = {};
    var approvers = {};

    if (!(0, _isEmpty.default)(userList)) {
      approvers['userIds'] = userList.map(function (user) {
        return user.userId;
      });
    }

    if (!(0, _isEmpty.default)(tagList)) {
      approvers['tags'] = tagList.map(function (tag) {
        return tag.userTagId;
      });
    }

    if (!(0, _isEmpty.default)(channelList)) {
      approvers['channelIds'] = channelList.map(function (el) {
        return el === null || el === void 0 ? void 0 : el.trim();
      });
    }

    if (!(0, _isEmpty.default)(slackAppChannels)) {
      approvers['slackAppChannels'] = slackAppChannels.map(function (el) {
        return el === null || el === void 0 ? void 0 : el.trim();
      });
    }

    if (!(0, _isEmpty.default)(teamsAppChannels)) {
      approvers['teamsAppChannels'] = teamsAppChannels;
    }

    if (!(0, _isEmpty.default)(notificationMedium)) {
      approvalsObj['notificationMedium'] = notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.map(function (notificationMedium) {
        return notificationMedium === null || notificationMedium === void 0 ? void 0 : notificationMedium.id;
      });
    }

    var timeToApproveTime = getMinutesFromHMTime(approvalMaxTime);

    if (timeToApproveTime) {
      approvalsObj['timeToApprove'] = timeToApproveTime;
    }

    var validForTime = isValidForInDays ? Number(validForDays) : getMinutesFromHMTime(validFor);

    if (validForTime) {
      approvalsObj['validFor'] = validForTime;
    }

    approvalsObj['isValidForInDays'] = Boolean(isValidForInDays);
    approvalsObj['managerApproval'] = {
      'required': required,
      'condition': condition
    };

    if (!(0, _isEmpty.default)(approvers)) {
      approvalsObj['approvers'] = approvers;
    }

    if (!(0, _isEmpty.default)(approvalsObj)) {
      conditionsObject['approval'] = approvalsObj;
    }
  }

  var getActiveStatus = function getActiveStatus() {
    if (isDraft) return false;else {
      if (areMembersEmpty({
        user: user,
        group: group,
        token: token,
        serviceIdentity: serviceIdentity,
        allUser: allUser,
        allGroup: allGroup,
        allToken: allToken,
        allServiceIdentity: allServiceIdentity
      })) return false;else {
        return isActive;
      }
    }
  };

  var policyObj = {
    name: name,
    isActive: getActiveStatus(),
    description: description,
    isDraft: isDraft || false,
    accessType: allowDeny,
    condition: translatedStrings.placeHolderCondition,
    isReadOnly: isReadOnly
  };

  if (isResourcePolicyPath()) {
    policyObj.accessLevel = accessLevel;
  }

  if (isServerAccessPath()) {
    policyObj.resourceLabels = removeEmptyLabelsValues(resourceLabels);
  }

  if ((0, _commonUtils.isApplicationProfilePolicyPath)() && !requiresHierarchicalModel) {
    policyObj.scopes = scopes || [];
  }

  policyObj['settings'] = settings || [];
  policyObj['members'] = membersObj;
  policyObj['condition'] = conditionsObject;

  if (Object.keys(conditionsObject).length) {
    policyObj['condition'] = isConditionTypeJSON ? conditionsObject : JSON.stringify(conditionsObject);
  } else {
    policyObj['condition'] = isConditionTypeJSON ? {} : '';
  }

  if (roles && roles.length) policyObj['roles'] = rolesArr;
  if (permissions && permissions.length) policyObj['permissions'] = permissionsArr;

  if (isReadOnly) {
    return {
      members: membersObj
    };
  }

  return policyObj;
};

exports.massagePolicyBeforeSave = massagePolicyBeforeSave;

var areMembersEmpty = function areMembersEmpty(values) {
  var user = values.user,
      group = values.group,
      token = values.token,
      serviceIdentity = values.serviceIdentity,
      allUser = values.allUser,
      allGroup = values.allGroup,
      allToken = values.allToken,
      allServiceIdentity = values.allServiceIdentity;
  return !user.length && !group.length && !token.length && !serviceIdentity.length && !allUser && !allGroup && !allToken && !allServiceIdentity;
};

exports.areMembersEmpty = areMembersEmpty;

var getApplicationName = function getApplicationName(resources, applicationsListData) {
  return resources.map(function (value) {
    if (value === '*') return value;else {
      var _applicationsListData;

      return applicationsListData === null || applicationsListData === void 0 ? void 0 : (_applicationsListData = applicationsListData.find(function (application) {
        return (application === null || application === void 0 ? void 0 : application.appContainerId) === value;
      })) === null || _applicationsListData === void 0 ? void 0 : _applicationsListData.applicationName;
    }
  });
};

exports.getApplicationName = getApplicationName;

var isLoading = function isLoading(value) {
  return value === _commonConstants.RESOURCE_STATUS.LOADING;
};

exports.isLoading = isLoading;

var isSuccess = function isSuccess(value) {
  return value === _commonConstants.RESOURCE_STATUS.SUCCESS;
};

exports.isSuccess = isSuccess;

var isError = function isError(value) {
  return value === _commonConstants.RESOURCE_STATUS.ERROR;
};

exports.isError = isError;

var isAccessBuilderPath = function isAccessBuilderPath() {
  return ['request-access', 'my-approvals', 'my-requests'].includes(location.pathname.split('/')[1]);
};

exports.isAccessBuilderPath = isAccessBuilderPath;

var isServerAccessPath = function isServerAccessPath() {
  return ['resources-manager'].includes(location.pathname.split('/')[2]);
};

exports.isServerAccessPath = isServerAccessPath;

var isResourcePolicyPath = function isResourcePolicyPath() {
  return ['resource-policies'].includes(location.pathname.split('/')[4]);
};

exports.isResourcePolicyPath = isResourcePolicyPath;

var isSAProfilePolicyPath = function isSAProfilePolicyPath() {
  var pathParts = location.pathname.split('/');
  return pathParts.includes('resources-manager') && pathParts.includes('profile-management');
};

exports.isSAProfilePolicyPath = isSAProfilePolicyPath;

var removeEmptyLabelsValues = function removeEmptyLabelsValues(obj) {
  return Object.fromEntries(Object.entries(obj).filter(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 2),
        value = _ref15[1];

    return !(Array.isArray(value) && value.length === 0) && !(Object.prototype.toString.call(value) === '[object Object]' && Object.keys(value).length === 0);
  }));
}; // Map over settings to check if settingsType is empty, and make the whole object empty if it is


exports.removeEmptyLabelsValues = removeEmptyLabelsValues;

var sanitizedSettings = function sanitizedSettings(settings) {
  return (settings === null || settings === void 0 ? void 0 : settings.filter(function (setting) {
    return setting != null && (setting === null || setting === void 0 ? void 0 : setting.settingsType) !== '' && (setting === null || setting === void 0 ? void 0 : setting.isInherited) !== true && (setting === null || setting === void 0 ? void 0 : setting.entityType) === 'POLICY';
  })) || [];
}; // Helper to find a setting by its type


exports.sanitizedSettings = sanitizedSettings;

var findSettingByType = function findSettingByType(settings, type) {
  return settings === null || settings === void 0 ? void 0 : settings.find(function (setting) {
    return (setting === null || setting === void 0 ? void 0 : setting.settingsType) === type;
  });
};

exports.findSettingByType = findSettingByType;

var compareAssociations = function compareAssociations() {
  var arr1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var arr2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (arr1.length !== arr2.length) return arr1;
  var isSame = arr1.every(function (obj1) {
    return arr2.some(function (obj2) {
      return obj1.type === obj2.type && obj1.value === obj2.value;
    });
  });
  return isSame ? [] : arr1;
};

exports.compareAssociations = compareAssociations;